
import { Component, Vue } from 'vue-property-decorator';
import { HPH_CART_GATE } from '@/constants/hph-cart-gate';

@Component
export default class CPHphCartDisabledModal extends Vue {
  public supportEmail = HPH_CART_GATE.SUPPORT_EMAIL;

  public close() {
    this.$store.dispatch('toggleHphCartDisabledNotice', false);
  }
}
